module.exports = __webpack_public_path__ + "assets/images/shareflard.b88e0436.png";